import cloneDeep from 'lodash/cloneDeep';

export const postLike = ({ newsId, likes, count }, rows) => {
  const updatedRows = cloneDeep(rows);
  updatedRows.forEach(row => {
    if (row.NewsID === newsId) {
      row.LikesCount = count;
      row.Likes = likes;
    }
  });
  return updatedRows;
};

export const getComments = ({ newsId, comments, count }, rows) => {
  const updatedRows = cloneDeep(rows);
  updatedRows.forEach(row => {
    if (row.NewsID === newsId) {
      row.CommentCount = count;
      row.Comments = comments;
    }
  });
  return updatedRows;
};
